import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=59a9f71e&scoped=true&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"
import style0 from "./Program.vue?vue&type=style&index=0&id=59a9f71e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a9f71e",
  null
  
)

export default component.exports